const  TForm  = {

    objectToFormData(obj, form, namespace) {
        let fd = form || new FormData();
        let formKey;
        for(let property in obj) {
            if(obj.hasOwnProperty(property)) {
                if(namespace) {
                    formKey = namespace + '[' + property + ']';
                } else {
                    formKey = property;
                }
                // if the property is an object, but not a File,
                // use recursivity.
                switch (typeof obj[property]) {
                    case "string":
                        fd.append(formKey, obj[property]);
                        break;
                    case "boolean":
                        fd.append(formKey, obj[property]);
                        break;
                    case "number":
                        fd.append(formKey, obj[property]);
                        break;
                    case "object":
                        if((obj[property] instanceof File)) {
                            fd.append(formKey, obj[property]);
                        }else{
                            TForm.objectToFormData(obj[property], fd, formKey);
                        }
                        break;
                    default :
                        fd.append(formKey, obj[property]);
                        break;
                }
            }
        }
        return fd;
    },


}

export default TForm;
